import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';


const DisputeTimer = ({ created_at }) => {
    const { t } = useTranslation();
    const [timeLeft, setTimeLeft] = useState('');
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        if (!created_at) {
            setTimeLeft('—');
            setIsExpired(true);
            return;
        }
        const startTime = new Date(created_at).getTime();
        const FIVE_DAYS_MS = 5 * 24 * 60 * 60 * 1000;
        const endTime = startTime + FIVE_DAYS_MS;

        const updateTimer = () => {
            const now = Date.now();
            const distance = endTime - now;
            if (distance <= 0) {
                setTimeLeft('expired');
                setIsExpired(true);
                return;
            }
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            let display = '';
            if (days > 0) display += `${days}d `;
            if (hours > 0 || days > 0) display += `${hours.toString().padStart(2, '0')}h `;
            if (minutes > 0 || hours > 0 || days > 0) display += `${minutes.toString().padStart(2, '0')}m `;
            display += `${seconds.toString().padStart(2, '0')}s`;

            setTimeLeft(display.trim());
            setIsExpired(false);
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [created_at]);

    const parsedTime = useMemo(() => {
        if (timeLeft === 'expired' || timeLeft === '—') {
            return { days: '00', hours: '00', minutes: '00', seconds: '00' };
        }

        const getValue = (unit) => {
            const match = timeLeft.match(new RegExp(`(\\d+)${unit}`));
            return match ? match[1].padStart(2, '0') : '00';
        };

        return {
            days: getValue('d'),
            hours: getValue('h'),
            minutes: getValue('m'),
            seconds: getValue('s'),
        };
    }, [timeLeft]);

    return (
        <div className={`dispute-timer-banner ${isExpired ? 'expired' : 'active'}`}>
            <div className="timer-left">
                <span className="status-badge">
                    {isExpired ? t('disputeTimer.expired') : t('disputeTimer.timeRemaining')}
                </span>
            </div>

            <div className="timer-right">
                <div className="time-box">
                    <span className="time-value">{parsedTime.days}</span>
                    <span className="time-label">{t('disputeTimer.days')}</span>
                </div>
                <div className="time-box">
                    <span className="time-value">{parsedTime.hours}</span>
                    <span className="time-label">{t('disputeTimer.hours')}</span>
                </div>
                <div className="time-box">
                    <span className="time-value">{parsedTime.minutes}</span>
                    <span className="time-label">{t('disputeTimer.minutes')}</span>
                </div>
                <div className="time-box highlight">
                    <span className="time-value">{parsedTime.seconds}</span>
                    <span className="time-label">{t('disputeTimer.seconds')}</span>
                </div>
            </div>
        </div>
    );
};

export default DisputeTimer;

